'use client';

import init, { push } from '@socialgouv/matomo-next';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { ClientConfig } from 'services/clientConfig';

export type MatomoProps = {
  siteId: string;
};

export function Matomo({ siteId }: MatomoProps) {
  const [isInitialized, setIsInitialized] = useState(false);
  const [previousPath, setPreviousPath] = useState('');

  const pathname = usePathname();
  const searchParams = useSearchParams();

  const clientConfig = ClientConfig.getInstance().getConfig();

  useEffect(() => {
    if (!siteId || isInitialized) return;

    init({
      url: clientConfig.matomo.url,
      siteId,
      nonce: clientConfig.nonce || undefined,
      onInitialization: () => {
        push(['setDocumentTitle', document.title]);
        push(['trackPageView']);

        push(['setCustomUrl', pathname]);

        push(['setCustomVariable', 1, 'Context Name', document.title, 'visit']);
      },
    });

    setIsInitialized(true);
  }, [siteId, isInitialized]);

  useEffect(() => {
    if (!pathname || !isInitialized) return;

    if (!previousPath) return setPreviousPath(pathname);

    push(['setReferrerUrl', previousPath]);
    push(['setCustomUrl', pathname]);
    setPreviousPath(pathname);

    setTimeout(() => {
      push(['setDocumentTitle', document.title]);

      push(['trackPageView']);
    });
  }, [pathname, searchParams]);

  return null;
}
